(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauTypeAccidentController', TableauTypeAccidentController);

    TableauTypeAccidentController.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauTypeAccidentController ($scope, $state, ParseLinks, AlertService) {


    }
})();
